// Приглашение — 3 шага, состояние держим на <html>, показ экранов решает CSS (Wedding.styl).
// 1) выбор языка        → data-lang        (модуль Hello)
// 2) клик по печати      → data-opened + запуск фоновой музыки
// 3) «другой язык»       → снимаем оба атрибута + стоп музыки (возврат к выбору языка)
// Ничего не сохраняем: после перезагрузки снова экран выбора языка.

// global-сборка Lenis (browserify не парсит ESM .mjs, поэтому берём IIFE-билд,
// который кладёт конструктор в globalThis.Lenis)
import "lenis/dist/lenis.min.js";
import { initHello } from "../Hello/Hello";
import { initEnvelope } from "../Envelope/Envelope";
import { initCountdown } from "../Date/Date";
import { initReveal, resetReveal } from "./reveal";

const root = document.documentElement;
const audio = document.getElementById("bg-audio");

// Плавный «слоу»-скролл (Lenis). lerp ниже → скролл «тягучее».
// syncTouch включает эффект и на телефоне; если ощущается лагом — поставь false
// (тогда на тач-устройствах останется нативный скролл).
const lenis = new window.Lenis({
	lerp: 0.08,
	smoothWheel: true,
	syncTouch: true,
});

function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

// Экран приветствия: выбор языка
initHello();
// Экран конверта: открытие письма + музыка
initEnvelope();
// Обратный отсчёт до торжества
initCountdown();
// Появление элементов при скролле (.anim-item)
initReveal();

document.addEventListener("click", (event) => {
	// вкл/выкл звук
	const soundButton = event.target.closest("[data-sound]");
	if (soundButton) {
		if (audio) {
			audio.muted = !audio.muted;
			soundButton.classList.toggle("is-muted", audio.muted);
		}
		return;
	}

	// вернуться к выбору языка
	if (event.target.closest("[data-back]")) {
		root.removeAttribute("data-lang");
		root.removeAttribute("data-opening");
		root.removeAttribute("data-opened");
		// сбрасываем появления, чтобы при повторном открытии всё проиграло заново
		resetReveal();
		if (audio) {
			audio.pause();
			audio.currentTime = 0;
		}
		const sb = document.querySelector("[data-sound]");
		if (sb) sb.classList.remove("is-muted");
		lenis.scrollTo(0, { immediate: true });
	}
});
